import React, { useState, useEffect } from 'react';
import '../styles/landing.css';

const backgroundImages = [
    'Crimson-Atlantis-Unicycle-Creeper.png',
    'Astronaut-Feline-Sunrise-Adventure.png',
    'Cosmic-Neon-Octopus-Paradise.png',
    'Cybernetic Dandelion-Solarium-Extraterrestrial-Coral.png',
    'Lunar-Blossom-Abstract-Serenity.png',
    'Lunar-Carousel-Origami.png',
    'Serpentine-Moonlit-Ballet-Mystique.png',
    'Submarine-Solar-Lanterns-Starlight.png'
].map(path => `${process.env.PUBLIC_URL}/aiart-assets/${path}`);

const BackgroundGallery = () => {
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const [imagesLoaded, setImagesLoaded] = useState(false);
    const [isInitialLoad, setIsInitialLoad] = useState(true);

    useEffect(() => {
        // Preload all images
        const loadImages = async () => {
            try {
                const imagePromises = backgroundImages.map(src => {
                    return new Promise((resolve, reject) => {
                        const img = new Image();
                        img.src = src;
                        img.onload = resolve;
                        img.onerror = reject;
                    });
                });

                await Promise.all(imagePromises);
                console.log('All images loaded successfully');
                setImagesLoaded(true);

                // Set initial load to false after a brief delay
                setTimeout(() => {
                    setIsInitialLoad(false);
                }, 100);
            } catch (error) {
                console.error('Error loading images:', error);
            }
        };

        loadImages();
    }, []);

    useEffect(() => {
        if (!imagesLoaded) return;

        const interval = setInterval(() => {
            setCurrentImageIndex((prevIndex) =>
                (prevIndex + 1) % backgroundImages.length
            );
            console.log('Changing background image');
        }, 8000);

        return () => clearInterval(interval);
    }, [imagesLoaded]);

    return (
        <div className="landing-background">
            {backgroundImages.map((src, index) => (
                <img
                    key={src}
                    src={src}
                    alt={`Background ${index + 1}`}
                    className={`background-image ${isInitialLoad ? 'initial-load' : ''} ${imagesLoaded && index === currentImageIndex ? 'active' : ''
                        }`}
                />
            ))}
            <div className="background-overlay" />
        </div>
    );
};

export default BackgroundGallery; 